import { render } from "./Loader.vue?vue&type=template&id=07d4b26e&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=07d4b26e&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d4b26e"],['__file',"src/assets/js/components/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07d4b26e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07d4b26e', __exports__)) {
    api.reload('07d4b26e', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=07d4b26e&scoped=true", () => {
    api.rerender('07d4b26e', render)
  })

}


export default __exports__